import { NotificationManager, PaymentV2Api, SessionStorageManager } from '@atlas/core';

import { POSTHOG_PAGE_REFER, POSTHOG_SESSION_KEYS } from 'common/constants';
import { clampAmountToLimits } from 'src/helpers/clampAmountToLimits';

export const buildPaymentUrl = (base, amount, pm) => {
  const clampedAmount = clampAmountToLimits(amount, pm);
  return clampedAmount ? `${base}?amount=${clampedAmount}` : base;
};

export const showAlternativeMethodsOrError = async ({
  fallbackError,
  onSelectMethod,
  onViewAll,
  operationType,
  pmId,
}) => {
  try {
    const response = await PaymentV2Api.getAlternativeMethods({
      altToPmId: pmId,
      operationType,
    });

    const methods = response?.data ?? [];

    if (methods.length > 0) {
      const setAlternativePaymentPageRefer = () => {
        SessionStorageManager.setItem(
          POSTHOG_SESSION_KEYS.DEPOSIT_PAGE_REFER,
          POSTHOG_PAGE_REFER.ALTERNATIVE_PAYMENT_METHOD_POP_UP,
        );
      };

      NotificationManager.display({
        data: {
          methods,
          onSelectMethod: method => {
            setAlternativePaymentPageRefer();
            onSelectMethod(method);
          },
          onViewAll: () => {
            setAlternativePaymentPageRefer();
            onViewAll();
          },
        },
        type: 'alternativeMethods',
      });
    } else {
      fallbackError();
    }
  } catch {
    fallbackError();
  }
};
